/* Built In Imports */

/* External Imports */
import { Box, Flex, SimpleGrid, useTheme, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import SimpleButton from '@components/Buttons/SimpleButton';
import SectionTitle from '@components/Headings/SectionTitle';

/* Services */

/**
 * Renders the Artwork Text 3 Group Column component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @returns {ReactElement} Artwork Text 3 Group Column component
 */
const Benefits3GroupColumn = ({ sectionContent, sectionId }) => {
    let suryaShaktiBenefits = sectionId === 'surya-shakti-benefits'
    return (
        // <Box display={'grid'} pos={'relative'} h={{ base: '100%', md: 'auto' }}>
        <Box
            as="div"
            width={{ lg: '100%' }}
            bg={suryaShaktiBenefits ? '#663723' : '#405C47'}
            clipPath={suryaShaktiBenefits ? {base: 'polygon(0 0, 100% 0, 100% 100%, 0 97%)', md: 'polygon(0 0, 100% 0, 100% 100%, 0 93%)'} : {base: 'polygon(0 100%, 0% 0, 6000% 100%)', lg: 'polygon(0 100%, 0% 0, 1500% 100%)'}}
            pt={suryaShaktiBenefits ? { base: '20px', md: '55px', lg: '55px' } : { base: '90px', md: '150px', lg: '150px' }}
            pb={suryaShaktiBenefits ? { base: '0px', md: '0px', lg: '0px' } : { base: '0px', md: '20px', lg: '20px' }}
            display={'flex'}
            flexDir={'column'}
            position={'relative'}
        >
            {suryaShaktiBenefits ?             
            <Box display={{ base: 'none', md: 'none', lg: 'block' }} position={'absolute'} right={'0'} top={'2.5rem'}>
                <LazyLoadImageComponent
                src={'https://www.datocms-assets.com/46272/1744106813-suryashaktistickimg2.png'}
                />
            </Box>
            : 
            <Box display={{ base: 'none', md: 'none', lg: 'block' }} position={'absolute'} right={'0'} bottom={'3rem'}>
                <svg width="267" height="154" viewBox="0 0 267 154" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.5">
                        <path d="M202.358 144.536C197.232 142.447 193.398 139.853 195.93 135.053C204.589 118.631 201.736 101.486 198.118 85.021C190.909 52.2391 172.63 27.4101 139.194 17.9331C109.044 9.38955 79.3735 12.5486 52.3084 29.5091C40.6955 36.7869 28.3757 44.0752 22.6272 57.4601C9.70117 87.5735 18.2552 109.439 47.6249 123.694C55.9839 127.749 65.0553 130.713 74.1104 132.896C99.509 139.025 133.24 120.318 140.402 94.9515C144.658 79.8738 141.014 65.2284 129.828 53.0248C120.061 42.3665 108.205 40.6262 95.1843 44.0806C83.139 47.2765 70.023 49.1171 65.2186 63.794C62.2284 72.923 64.2959 81.266 71.2257 84.9261C83.4187 91.3601 91.767 90.0469 99.4667 79.4308C89.4992 79.9318 84.2411 75.6231 84.5839 66.0196C98.5437 55.5247 105.083 55.857 113.226 67.3433C120.156 77.1157 117.487 91.5024 107.404 98.6959C95.6432 107.081 75.4289 106.396 65.2926 97.2614C49.9776 83.4599 44.8775 67.9813 52.8356 55.4403C63.8368 38.1106 78.0761 26.6876 100.764 27.7054C131.853 29.0977 158.106 55.609 156.945 86.6716C155.79 117.655 133.019 144.567 102.705 150.833C70.0601 157.583 41.1488 151.497 15.7871 128.419C-2.22813 112.023 -4.79102 73.6929 7.92409 53.5365C30.5275 17.6905 64.4271 3.6623 105.257 2.8976C122.196 2.58118 138.519 6.54704 154.52 11.2143C185.994 20.4013 201.862 44.1702 209.905 74.0989C214.161 89.9308 215.495 106.19 213.017 122.613C211.772 130.866 209.019 138.191 202.358 144.525V144.536Z" fill="#2A4631" />
                        <path d="M243.34 0C243.34 15.0619 243.704 28.2886 243.266 41.4889C242.327 69.6035 243.265 97.5968 247.031 125.485C248.154 133.812 248.793 141.976 238.43 145.425C232.713 143.046 231.764 138.917 232.618 133.469C238.029 98.9258 234.042 64.5722 230.514 30.1819C229.523 20.5361 224.976 9.66693 236.415 2.51039C237.391 1.90391 238.609 1.69289 243.34 0Z" fill="#2A4631" />
                        <path d="M255.229 2.87988C262.053 3.39144 264.085 6.50812 263.985 13.2955C263.447 50.655 264.274 87.9988 265.993 125.332C266.273 131.45 266.652 138.406 260.994 143.737C255.419 141.443 252.967 138.48 253.252 131.835C254.791 95.7829 258.146 59.7049 252.466 23.648C251.396 16.8448 249.259 9.11878 255.229 2.87988Z" fill="#2A4631" />
                        <path d="M200.308 3.38261C208.856 3.58301 215.1 9.57398 215.153 17.6271C215.206 25.5641 207.891 32.225 199.005 32.3252C190.888 32.4201 185.287 25.5062 185.408 15.544C185.503 7.82841 191.209 3.17166 200.301 3.38261H200.308ZM206.224 20.1164C201.768 15.333 198.699 12.9493 193.715 16.0714C194.623 25.6697 199.157 23.9768 206.224 20.1164Z" fill="#2A4631" />
                    </g>
                </svg>
            </Box>}
            {suryaShaktiBenefits ? 
                <SectionTitle titleObj={sectionContent?.[0]?.title?.[0]} color={'#F8E9D5'} dividerUrl={'https://www.datocms-assets.com/46272/1744106053-suryashaktidivider2.png'}/>: 
            <Text
                textAlign={'center'}
                fontSize={{ base: '26px', md: '36px', lg: '36px' }}
                fontWeight={600}
                color={'#fff'}
                my={{ md: '20px', lg: '20px' }}
                width={{ lg: '810px' }}
                alignSelf={'center'}
                mx={'20px'}
                fontFamily={'FedraSerifAStdBook'}
                lineHeight={'130%'}
            >{sectionContent?.[0]?.title?.[0]?.titleText}</Text>}
            <Box
                as="div"
                display="flex"
                flexWrap="wrap"
                // justifyContent={{ md: 'center', base: 'normal' }}
                // alignItems={{ md: 'center', base: 'normal' }}
                margin="60px auto 0 auto"
                fontSize="18px"
                gap={suryaShaktiBenefits ? "15px" : {base: '20px', md: "40px"}}
                width={{ base: '100%', md: '737px', lg: suryaShaktiBenefits ? '980px' : '810px' }}
                pl={suryaShaktiBenefits ? {base:'2.5rem', md: '4rem', lg: '3rem'} : undefined}
                pb={{ md: '30px', lg: '20px' }}
            >
                {sectionContent &&
                    sectionContent?.[0]?.benefits?.map(data => {
                        return (
                            <Box
                                //turn this on after you have done
                                // p="0 10px"
                                display={{
                                    base: 'block',
                                    md: 'block',
                                }}
                                width={{ base: '100%', md: '48%', lg: '30%' }}
                                marginBottom={{ base: '26.07px', md: '33px', lg: '36px' }}
                                mx={{base:'50px', md: '0px', lg: '0px'}}
                            >
                                <Flex
                                    alignItems="center"
                                    justifyContent={{ base: 'center', md: 'center', lg:'center' }}
                                    // as="div"
                                    // minWidth={{ base: '37.17px', md: '100%', lg: '100%' }}
                                    // maxW={{ base: '37.17px', md: '100%', lg: '100%' }}
                                    // mr="17.93px"
                                    textAlign={{ base: 'center', md: 'center' }}
                                    maxH={{ md: '100px', lg: '100px' }} 
                                    width={suryaShaktiBenefits ? '232px' : undefined}
                                >
                                    <LazyLoadImageComponent
                                        loading="lazy"
                                        src={data?.image?.url}
                                        title={data?.image?.title}
                                        alignSelf={'center'}
                                        textAlign={'center'}
                                        // minW={'31px'}
                                        objectFit={{ base: 'cover', md: 'cover' }}
                                        m={{ base: '0 0 0 0', md: '0 0 22px 0' }} 
                                    />
                                </Flex>
                                <Text
                                    fontFamily="FedraSansStd-book, sans-serif"
                                    fontSize={'16px'}
                                    color="#fff"
                                    textAlign={'center'}
                                    py={{ base: '5px', md: '5px', lg: '5px' }}
                                    fontWeight={600}
                                    lineHeight={'25px'}
                                    width={suryaShaktiBenefits ? undefined :  { base: '100%', md: '243px' }}
                                >
                                    {data?.boldText}
                                </Text>
                                <Text
                                    fontFamily={suryaShaktiBenefits ? 'MuktaMalar' : "FedraSansStd-book, sans-serif"}
                                    fontSize={suryaShaktiBenefits ? '18px' : '16px'}
                                    color={suryaShaktiBenefits ? '#FFF9E9' : "#fff"}
                                    textAlign={'center'}
                                    fontWeight={400}
                                    lineHeight={'25px'}
                                    width={suryaShaktiBenefits ? '232px' : { base: '100%', md: '243px' }}
                                    px={suryaShaktiBenefits ? undefined : {base:'1.2rem', md: '0px'}}
                                >
                                    {data?.text}
                                </Text>
                            </Box>
                        );
                    })}
            </Box>
            <Flex justifyContent={'center'} mb={{base:'20px', md: '30px'}}>
                <SimpleButton
                    style={sectionContent?.[1]}
                    bType={sectionContent?.[1]?.sectionId}
                    color={'#28231E'}
                    lineHeight={'56px'}
                    w={'206px'}
                />
            </Flex>
        </Box>
    );
};

export default Benefits3GroupColumn;